import { FC, ReactNode } from "react";
import { Alert } from "react-bootstrap";
import { Nullable } from "../../../../../../../../../shared/src/@types/util";

const CLASSNAME = "file-viewer-html";

export type FileViewerHTMLProps = {
  htmlContent: Nullable<string>;
  errorMessage?: ReactNode;
};

const FileViewerHTML: FC<FileViewerHTMLProps> = ({
  htmlContent,
  errorMessage,
}) => {
  if (!htmlContent) {
    return (
      <div className={CLASSNAME}>
        <Alert variant="danger">
          {errorMessage ?? "Failed to load HTML content"}
        </Alert>
      </div>
    );
  }

  return (
    <div
      className={`${CLASSNAME} p-5`}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
};

FileViewerHTML.defaultProps = {
  errorMessage: undefined,
};

export default FileViewerHTML;
